var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"position-relative",attrs:{"variant":"danger","block":_vm.block},on:{"click":function($event){return _vm.reboot()}}},[_c('b-icon',{attrs:{"icon":"power"}}),_vm._v("\n\tReboot Transceiver\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }